import React from "react";

const Footer = () => {
  return (
    <footer className="color-bg text-light py-3 text-center text-muted ">
      <small>Copyright&copy; 2021 | All rights reserved.</small>
    </footer>
  );
};

export default Footer;
